import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Text } from "grommet";
import * as React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import CustomButton from "../components/CustomButton";
import CreateStat from "./CreateStat";
import StatProfile from "./StatProfile";
import { StatRow } from "./StatRow";
import { getStats, StatViewModel } from "./StatsStore";




export const newStatIcon = (
    <span className="fa-layers fa-fw">
        {/* @ts-ignore */}
        <FontAwesomeIcon size="lg" icon={["fad", "stars"]}></FontAwesomeIcon>
        <FontAwesomeIcon icon={["fad", "plus"]} swapOpacity transform="up-10 right-10" />
    </span>
);

const StatsManagement = () => {
    const [stats, setStats] = React.useState([] as StatViewModel[]);
    let { pathname } = useLocation();

    React.useEffect(() => {
        getStats().then((response) => {
            setStats(response.result);
        });
    }, [pathname]);

    return (
        <div>
            <Routes>
                <Route path={"create"} element={<CreateStat />}></Route>
                <Route path={":statID/*"} element={<StatProfile />}></Route>
                <Route
                    path={""}
                    element={
                        <>
                            <Box direction="row" pad={"small"}>
                                <CustomButton path={`/stats/create`} icon={newStatIcon} label="New Stat"></CustomButton>
                            </Box>
                            <Box gap="small">
                                <Text weight={"bold"} style={{ textTransform: "uppercase" }}>
                                    Stats
                                </Text>
                                {stats.map((stat) => (
                                    <StatRow key={stat.id} stat={stat}>
                                        <></>
                                    </StatRow>
                                ))}
                            </Box>
                        </>
                    }
                ></Route>
            </Routes>
        </div>
    );
};

export default StatsManagement;
